import { render, staticRenderFns } from "./SetPaperStepTwoSingle.vue?vue&type=template&id=3b790a84&scoped=true&"
import script from "./SetPaperStepTwoSingle.vue?vue&type=script&lang=js&"
export * from "./SetPaperStepTwoSingle.vue?vue&type=script&lang=js&"
import style0 from "./SetPaperStepTwoSingle.vue?vue&type=style&index=0&id=3b790a84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b790a84",
  null
  
)

export default component.exports